import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

/**
 * Initialises tooltips for elements carrying a `data-tippy-content` attribute.
 *
 * The markup is emitted by the pricing blocks (`pricing-data-feature` and the
 * server-rendered pricing feature table), which reference this script through
 * their `viewScript`. WordPress therefore only enqueues tippy on pages that
 * actually render a tooltip, instead of shipping it site-wide.
 */
( () => {
	const elements = document.querySelectorAll< HTMLElement >( '[data-tippy-content]' );
	if ( ! elements.length ) {
		return;
	}

	elements.forEach( ( element ) => {
		// Make non-interactive tooltip triggers keyboard focusable.
		if ( 'SPAN' === element.tagName || 'DIV' === element.tagName ) {
			element.setAttribute( 'tabindex', '0' );
		}
	} );

	tippy( elements, {
		allowHTML: true,
		interactive: true,
		delay: [ 150, 0 ],
	} );
} )();
